function mergeSort(i, j, arr) {
  let mid = Math.floor((i + j) / 2);
  if (i < j) {
    mergeSort(i, mid, arr);
    mergeSort(mid + 1, j, arr);
    let mergeArr = merge1(i, mid, j, arr);
    for (let k = 0; k <= j - i; k++) {
      arr[i + k].name = mergeArr[k].name;
      arr[i + k].id = mergeArr[k].id;
    }
  }
}

function merge1(start, mid, end, arr) {
  let i,
    index1 = 0,
    index2 = 0;
  let a = arr.slice(start, mid + 1);
  let b = arr.slice(mid + 1, end + 1);
  console.log("a", "b", a, b);
  let merge = [];
  for (i = 0; i < end - start + 1; i++) {
    merge.push({ name: "", id: -1 });
    // console.log("i", arr[i]);
    if (a[index1].name < b[index2].name) {
      merge[i].name = a[index1].name;
      merge[i].id = a[index1].id;
      index1++;
    } else {
      merge[i].name = b[index2].name;
      merge[i].id = b[index2].id;
      index2++;
    }

    if (index1 == mid + 1 || index2 == end - mid) break;
  }

  if (index1 == mid + 1)
    for (i = index2; i < end - mid; i++) {
      merge.push({
        name: "",
        id: -1,
      });
      merge[index1 + i].name = b[i].name;
      merge[index1 + i].id = b[i].id;
    }
  else if (index2 == end - mid)
    for (i = index1; i < mid + 1; i++) {
      merge.push({
        name: "",
        id: -1,
      });
      merge[index2 + i].name = a[i].name;
      merge[index2 + i].id = a[i].id;
    }

  return merge;
}

function bubbleSort(arr) {
  let i, j, temp;

  for (i = 0; i < arr.length; i++) {
    for (j = i; j < arr.length; j++) {
      if (arr[i].name > arr[j].name) {
        temp = arr[i];
        arr[i] = arr[j];
        arr[j] = temp;
      }
    }
  }
  return arr;
}

function titleCase(str) {
  var splitStr = str.toLowerCase().split(" ");
  for (var i = 0; i < splitStr.length; i++) {
    // You do not need to check if i is larger than splitStr length, as your for does that for you
    // Assign it back to the array
    splitStr[i] =
      splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
  }
  // Directly return the joined string
  return splitStr.join(" ");
}

export default function sort(data) {
  let arr = [...data];
  for (let k = 0; k < arr.length; k++) {
    arr[k].name = arr[k].name === null ? "" : arr[k].name;
    arr[k].name = titleCase(arr[k].name);
  }
  //   mergeSort(0, arr.length - 1, arr);
  arr = bubbleSort(arr);
  return arr;
}
